export interface FontOption {
  /** Nazwa rodziny użyta w CSS i w canvas. */
  family: string;
  label: string;
  /** Grubości faktycznie wczytane z Google Fonts, inne przeglądarka tylko symuluje. */
  weights: number[];
  italic: boolean;
}

export const FONT_OPTIONS: FontOption[] = [
  { family: 'Roboto', label: 'Roboto', weights: [300, 400, 500, 700, 900], italic: true },
  { family: 'Montserrat', label: 'Montserrat', weights: [400, 600, 700, 900], italic: true },
  { family: 'Poppins', label: 'Poppins', weights: [400, 600, 700, 900], italic: true },
  { family: 'Inter', label: 'Inter', weights: [400, 600, 700, 900], italic: false },
  { family: 'Oswald', label: 'Oswald', weights: [400, 600, 700], italic: false },
  { family: 'Bebas Neue', label: 'Bebas Neue', weights: [400], italic: false },
  { family: 'Anton', label: 'Anton', weights: [400], italic: false },
  { family: 'Playfair Display', label: 'Playfair Display', weights: [400, 700, 900], italic: true },
  { family: 'Lora', label: 'Lora', weights: [400, 700], italic: true },
  { family: 'Georgia', label: 'Georgia', weights: [400, 700], italic: true },
];

export const DEFAULT_FONT = 'Montserrat';

export const findFont = (family: string): FontOption => (
  FONT_OPTIONS.find((font) => font.family === family) ?? FONT_OPTIONS[0]
);

const GOOGLE_FONTS_HREF = 'https://fonts.googleapis.com/css2'
  + '?family=Anton'
  + '&family=Bebas+Neue'
  + '&family=Inter:wght@400;600;700;900'
  + '&family=Lora:ital,wght@0,400;0,700;1,400;1,700'
  + '&family=Montserrat:ital,wght@0,400;0,600;0,700;0,900;1,400;1,700'
  + '&family=Oswald:wght@400;600;700'
  + '&family=Playfair+Display:ital,wght@0,400;0,700;0,900;1,400;1,700'
  + '&family=Poppins:ital,wght@0,400;0,600;0,700;0,900;1,400;1,700'
  + '&display=swap';

const FONTS_LINK_ID = 'ads-generator-fonts';

/**
 * Dokłada arkusz Google Fonts przy pierwszym wejściu do generatora.
 * Trzymamy to poza `index.css`, żeby reszta panelu nie pobierała krojów,
 * których nigdzie nie używa.
 */
export const ensureFontsLoaded = (): void => {
  if (document.getElementById(FONTS_LINK_ID)) return;
  const link = document.createElement('link');
  link.id = FONTS_LINK_ID;
  link.rel = 'stylesheet';
  link.href = GOOGLE_FONTS_HREF;
  document.head.appendChild(link);
};

/** Rodzina razem z awaryjnym krojem, w formie akceptowanej przez canvas i CSS. */
export const cssFontFamily = (family: string): string => `"${family}", Roboto, Arial, sans-serif`;
